// AUTO-GENERATED by scripts/build_products_data.py from
// "docs/knowledge-base/Export product list REACH.xlsx". Do not edit by hand.
// Supplier/manufacturer names are intentionally excluded.

export interface Grade {
  group: string
  grade: string
  mfi: string
  base: string
}

export interface ProductCategory {
  name: string
  grades: Grade[]
}

export interface Polymer {
  code: 'PP' | 'PE'
  name: string
  categories: ProductCategory[]
}

export const products: Polymer[] = [
  {
    "code": "PP",
    "name": "Polypropylene (PP)",
    "categories": [
      {
        "name": "Homopolymer",
        "grades": [
          {
            "group": "Raffia / Yarn",
            "grade": "T03",
            "mfi": "2.3-3.7",
            "base": "OIL / PDH"
          },
          {
            "group": "Raffia / Yarn",
            "grade": "1102K",
            "mfi": "2.8",
            "base": "COAL"
          },
          {
            "group": "Raffia / Yarn",
            "grade": "T30S",
            "mfi": "2.9-3.5",
            "base": "OIL"
          },
          {
            "group": "Raffia / Yarn",
            "grade": "L5E89",
            "mfi": "2.7-3.7 / 2026-03-04 00:00:00",
            "base": "COAL / OIL"
          },
          {
            "group": "Raffia / Yarn",
            "grade": "HP550J",
            "mfi": "3",
            "base": "COAL / OIL / PDH"
          },
          {
            "group": "Raffia / Yarn",
            "grade": "S1003",
            "mfi": "3",
            "base": "COAL / OIL"
          },
          {
            "group": "Raffia / Yarn",
            "grade": "LHP456J",
            "mfi": "3.5-4",
            "base": "OIL"
          },
          {
            "group": "Raffia / Yarn",
            "grade": "L5E89H/S1005",
            "mfi": "4",
            "base": "COAL"
          },
          {
            "group": "Raffia / Yarn",
            "grade": "T05",
            "mfi": "4.5",
            "base": "PDH"
          },
          {
            "group": "Fiber",
            "grade": "Y26",
            "mfi": "24 / 25±2.5",
            "base": "OIL / PDH"
          },
          {
            "group": "Fiber",
            "grade": "Y25L",
            "mfi": "25",
            "base": "PDH"
          },
          {
            "group": "Fiber",
            "grade": "Y40",
            "mfi": "40",
            "base": "PDH"
          },
          {
            "group": "Fiber",
            "grade": "Y40L",
            "mfi": "40",
            "base": "PDH"
          },
          {
            "group": "Fiber",
            "grade": "1101SC",
            "mfi": "40",
            "base": "COAL"
          },
          {
            "group": "Fiber",
            "grade": "Z30S",
            "mfi": "18-32 / 22-27 / 25±5.0",
            "base": "OIL"
          },
          {
            "group": "Fiber",
            "grade": "S2040",
            "mfi": "33-41 / 40",
            "base": "OIL / PDH"
          },
          {
            "group": "Fiber",
            "grade": "S2040H",
            "mfi": "38.0±6.0",
            "base": "COAL"
          },
          {
            "group": "Fiber",
            "grade": "Y38QS",
            "mfi": "30-47",
            "base": "OIL"
          },
          {
            "group": "Fiber",
            "grade": "H39S-2/-3",
            "mfi": "39-40",
            "base": "OIL"
          },
          {
            "group": "Fiber",
            "grade": "Y0450/Y0370 /DG45S/LHP565S/HT40S",
            "mfi": "38-40",
            "base": "OIL"
          },
          {
            "group": "Fiber",
            "grade": "Y381H",
            "mfi": "38",
            "base": "PDH"
          },
          {
            "group": "Injection",
            "grade": "HP500N",
            "mfi": "12.0±3.0 / 12.5±0.5 / 12±1.6 / 2026-08-12 00:00:00",
            "base": "COAL / OIL / PDH"
          },
          {
            "group": "Injection",
            "grade": "M12",
            "mfi": "12",
            "base": "PDH"
          },
          {
            "group": "Injection",
            "grade": "HP500P",
            "mfi": "16",
            "base": "OIL"
          },
          {
            "group": "Injection",
            "grade": "1100NG",
            "mfi": "2026-10-14 00:00:00",
            "base": "OIL"
          },
          {
            "group": "Injection",
            "grade": "1100N",
            "mfi": "12±3.6",
            "base": "COAL"
          },
          {
            "group": "Injection",
            "grade": "V30G",
            "mfi": "14.5-15.0 / 16",
            "base": "COAL / OIL"
          },
          {
            "group": "Injection",
            "grade": "M17",
            "mfi": "17",
            "base": "PDH"
          },
          {
            "group": "Injection",
            "grade": "1145R",
            "mfi": "20",
            "base": "COAL"
          },
          {
            "group": "Injection",
            "grade": "M251H",
            "mfi": "25±4",
            "base": "PDH"
          },
          {
            "group": "Injection",
            "grade": "552R PC",
            "mfi": "28±2",
            "base": "COAL"
          },
          {
            "group": "Thin Wall",
            "grade": "M600X",
            "mfi": "63.0±3.0",
            "base": "MTO"
          },
          {
            "group": "Thin Wall",
            "grade": "HP648T",
            "mfi": "70",
            "base": "OIL"
          },
          {
            "group": "Thin Wall",
            "grade": "MP70",
            "mfi": "72.7",
            "base": "OIL"
          },
          {
            "group": "Thin Wall",
            "grade": "648T-M",
            "mfi": "70",
            "base": "OIL"
          },
          {
            "group": "Thin Wall",
            "grade": "M700B",
            "mfi": "70",
            "base": "OIL"
          },
          {
            "group": "Thin Wall",
            "grade": "PPH-G70T",
            "mfi": "70",
            "base": "PDH"
          },
          {
            "group": "Thin Wall",
            "grade": "PPH-G75T",
            "mfi": "75",
            "base": "PDH"
          },
          {
            "group": "Thin Wall",
            "grade": "648T/648ET",
            "mfi": "70",
            "base": "OIL"
          }
        ]
      },
      {
        "name": "Thermoforming",
        "grades": [
          {
            "group": "Thermoforming",
            "grade": "T1803",
            "mfi": "2.0-4.0",
            "base": "COAL"
          },
          {
            "group": "Thermoforming",
            "grade": "PPR-ET03",
            "mfi": "3",
            "base": "PDH"
          }
        ]
      },
      {
        "name": "Film",
        "grades": [
          {
            "group": "BOPP",
            "grade": "BOPP T36F",
            "mfi": "3.0±0.5",
            "base": "PDH"
          },
          {
            "group": "BOPP",
            "grade": "BOPP F03H",
            "mfi": "3.1",
            "base": "PDH"
          },
          {
            "group": "BOPP",
            "grade": "BOPP HP520J",
            "mfi": "3.1±0.2",
            "base": "PDH"
          },
          {
            "group": "BOPP",
            "grade": "BOPP 1103K",
            "mfi": "3.2",
            "base": "COAL"
          },
          {
            "group": "BOPP",
            "grade": "BOPP PPH-F03",
            "mfi": "3.4",
            "base": "PDH"
          },
          {
            "group": "BOPP",
            "grade": "BOPP PPH F03D",
            "mfi": "3.0±0.30",
            "base": "OIL"
          },
          {
            "group": "BOPP",
            "grade": "BOPP PPH0303",
            "mfi": "3.0±0.30",
            "base": "OIL"
          },
          {
            "group": "BOPP",
            "grade": "BOPP L5D98",
            "mfi": "2.6-3.4 / 3.4±0.5",
            "base": "COAL / OIL"
          },
          {
            "group": "BOPP",
            "grade": "PPH-GF03H",
            "mfi": "3",
            "base": "PDH"
          },
          {
            "group": "CPP Homo",
            "grade": "HA510M",
            "mfi": "7.00-9.00",
            "base": "OIL"
          },
          {
            "group": "CPP Homo",
            "grade": "PPH-F08",
            "mfi": "8",
            "base": "OIL"
          },
          {
            "group": "CPP Homo",
            "grade": "PPH-FH08",
            "mfi": "8",
            "base": "OIL"
          },
          {
            "group": "CPP Homo",
            "grade": "PPH-GF08",
            "mfi": "8",
            "base": "PDH"
          },
          {
            "group": "CPP COPP",
            "grade": "F800E",
            "mfi": "8",
            "base": "OIL"
          },
          {
            "group": "CPP COPP",
            "grade": "F800EDF",
            "mfi": "8",
            "base": "OIL"
          },
          {
            "group": "CPP Random",
            "grade": "TF1007",
            "mfi": "7.50±1.50",
            "base": "OIL"
          },
          {
            "group": "CPP Random",
            "grade": "PPR-F08E",
            "mfi": "8",
            "base": "OIL"
          },
          {
            "group": "CPP Random",
            "grade": "F800EDF",
            "mfi": "8",
            "base": "OIL"
          },
          {
            "group": "CPP Random",
            "grade": "F800E",
            "mfi": "8",
            "base": "OIL"
          },
          {
            "group": "CPP Random",
            "grade": "PPR-GF800E",
            "mfi": "8",
            "base": "PDH"
          },
          {
            "group": "CPP Random",
            "grade": "RP210M",
            "mfi": "7.00-9.00",
            "base": "OIL"
          },
          {
            "group": "IPP",
            "grade": "PPH-GF10S",
            "mfi": "10",
            "base": "PDH"
          }
        ]
      },
      {
        "name": "Copolymer",
        "grades": [
          {
            "group": "Block",
            "grade": "K8003",
            "mfi": "2.5±0.5",
            "base": "COAL / OIL / PDH"
          },
          {
            "group": "Block",
            "grade": "2500HY",
            "mfi": "2.0±0.6",
            "base": "COAL"
          },
          {
            "group": "Block",
            "grade": "EP300H",
            "mfi": "2.0±0.5",
            "base": "OIL / PDH"
          },
          {
            "group": "Block",
            "grade": "EP300K",
            "mfi": "4.2",
            "base": "COAL"
          },
          {
            "group": "Block",
            "grade": "K8009",
            "mfi": "8.5±2.5 / 9±1.5",
            "base": "COAL / OIL"
          },
          {
            "group": "Block",
            "grade": "EP300M",
            "mfi": "9",
            "base": "OIL"
          },
          {
            "group": "Block",
            "grade": "SP179",
            "mfi": "9",
            "base": "OIL"
          },
          {
            "group": "Block",
            "grade": "M09",
            "mfi": "2026-07-11 00:00:00",
            "base": "OIL"
          },
          {
            "group": "Block",
            "grade": "EP440N",
            "mfi": "10.0~14.0",
            "base": "OIL"
          },
          {
            "group": "Block",
            "grade": "EP540N",
            "mfi": "12.0±1.0",
            "base": "COAL"
          },
          {
            "group": "Block",
            "grade": "EP548RQ",
            "mfi": "26.0±2.0",
            "base": "COAL"
          },
          {
            "group": "Block",
            "grade": "K9928H",
            "mfi": "24-32",
            "base": "COAL"
          },
          {
            "group": "Block",
            "grade": "K7726H",
            "mfi": "23.0-33.0",
            "base": "COAL"
          },
          {
            "group": "Block",
            "grade": "M30RH",
            "mfi": "30.0±5.0",
            "base": "COAL"
          },
          {
            "group": "Block",
            "grade": "EP533N",
            "mfi": "30",
            "base": "OIL"
          },
          {
            "group": "Block",
            "grade": "EP548R",
            "mfi": "21.0±4.0",
            "base": "COAL"
          },
          {
            "group": "Block",
            "grade": "K9930H",
            "mfi": "30",
            "base": "OIL"
          },
          {
            "group": "Block",
            "grade": "EP508N",
            "mfi": "60",
            "base": "OIL"
          },
          {
            "group": "Block",
            "grade": "LA640T",
            "mfi": "60",
            "base": "OIL"
          },
          {
            "group": "Block",
            "grade": "EP649U",
            "mfi": "54-66",
            "base": "OIL"
          },
          {
            "group": "Block",
            "grade": "EP100N",
            "mfi": "100",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "T3802",
            "mfi": "2.0-4.0",
            "base": "COAL"
          },
          {
            "group": "Random",
            "grade": "M800E(MT-08)",
            "mfi": "8±2",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "PP-R,MT09-090(M800E)",
            "mfi": "10.0±2.0",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "K4826",
            "mfi": "18-34",
            "base": "COAL"
          },
          {
            "group": "Random",
            "grade": "RP340R",
            "mfi": "20",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "RP340N",
            "mfi": "12",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "RP346R",
            "mfi": "26",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "RP348P",
            "mfi": "16",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "M26ET",
            "mfi": "25",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "HCRP344R",
            "mfi": "28-30",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "MT 35",
            "mfi": "36.0±2.0",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "K4860M",
            "mfi": "55-75",
            "base": "COAL"
          },
          {
            "group": "Random",
            "grade": "MT50",
            "mfi": "53.7",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "MT60",
            "mfi": "60.0±10.0",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "PPR-MT25",
            "mfi": "25",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "PPR-MT40",
            "mfi": "40",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "PPR-MT60/ PPR-MT60M",
            "mfi": "60",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "PPR-MT65",
            "mfi": "60",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "HCM700B",
            "mfi": "70",
            "base": "OIL"
          },
          {
            "group": "Random",
            "grade": "MT75",
            "mfi": "75",
            "base": "OIL"
          },
          {
            "group": "PPR",
            "grade": "PA14D",
            "mfi": "0.28",
            "base": "OIL"
          },
          {
            "group": "PPR",
            "grade": "4220",
            "mfi": "0.3",
            "base": "OIL"
          },
          {
            "group": "PPR",
            "grade": "EH00",
            "mfi": "0.28",
            "base": "OIL"
          },
          {
            "group": "(thin Wall)",
            "grade": "MN60",
            "mfi": "60.0±5.0",
            "base": "PDH"
          },
          {
            "group": "(thin Wall)",
            "grade": "MN70",
            "mfi": "70.0±5.0",
            "base": "PDH"
          }
        ]
      }
    ]
  },
  {
    "code": "PE",
    "name": "Polyethylene (PE)",
    "categories": [
      {
        "name": "HDPE",
        "grades": [
          {
            "group": "Injection",
            "grade": "7260",
            "mfi": "2026-07-10 00:00:00 / 5.5-9.5 / 6.5-9.5 / 7~8",
            "base": "COAL / EDH / OIL"
          },
          {
            "group": "Injection",
            "grade": "8008",
            "mfi": "6.0-8.5",
            "base": "COAL / OIL"
          },
          {
            "group": "Injection",
            "grade": "8008T",
            "mfi": "6.0-8.5",
            "base": "OIL"
          },
          {
            "group": "Injection",
            "grade": "8008H",
            "mfi": "6.5-8.5",
            "base": "OIL"
          },
          {
            "group": "Injection",
            "grade": "6080",
            "mfi": "2026-07-10 00:00:00",
            "base": "OIL"
          },
          {
            "group": "Injection",
            "grade": "6081",
            "mfi": "6.5-9.2",
            "base": "COAL"
          },
          {
            "group": "Injection",
            "grade": "2911/H2911",
            "mfi": "20",
            "base": "OIL"
          },
          {
            "group": "Injection",
            "grade": "8920",
            "mfi": "20",
            "base": "OIL"
          },
          {
            "group": "Injection",
            "grade": "M200054F",
            "mfi": "20",
            "base": "OIL"
          },
          {
            "group": "Small Blow Molding",
            "grade": "5502A",
            "mfi": "0.2",
            "base": "OIL"
          },
          {
            "group": "Small Blow Molding",
            "grade": "HHM5502LW",
            "mfi": "0.35",
            "base": "OIL"
          },
          {
            "group": "Small Blow Molding",
            "grade": "5502",
            "mfi": "0.25±0.06",
            "base": "OIL"
          },
          {
            "group": "Small Blow Molding",
            "grade": "HD5502",
            "mfi": "0.3-0.4",
            "base": "OIL"
          },
          {
            "group": "Small Blow Molding",
            "grade": "HMN5502",
            "mfi": "0.3±0.15",
            "base": "OIL"
          },
          {
            "group": "Small Blow Molding",
            "grade": "5502W",
            "mfi": "0.15-0.25",
            "base": "OIL"
          },
          {
            "group": "Small Blow Molding",
            "grade": "6200",
            "mfi": "0.3-0.4",
            "base": "OIL"
          },
          {
            "group": "Small Blow Molding",
            "grade": "BM593",
            "mfi": "0.17-0.37",
            "base": "OIL"
          },
          {
            "group": "Small Blow Molding",
            "grade": "ZH5502H",
            "mfi": "0.25",
            "base": "OIL"
          },
          {
            "group": "Small Blow Molding",
            "grade": "ZH1158HS",
            "mfi": "2.5(5kg)",
            "base": "OIL"
          },
          {
            "group": "Medium Blow Molding",
            "grade": "50100",
            "mfi": "10±2.5 (21.6kg)",
            "base": "OIL"
          },
          {
            "group": "Medium Blow Molding",
            "grade": "50100S",
            "mfi": "7(21.6kg)",
            "base": "OIL"
          },
          {
            "group": "Medium Blow Molding",
            "grade": "HM5411EA",
            "mfi": "8-12(21.6kg)",
            "base": "OIL"
          },
          {
            "group": "Large Blow Molding",
            "grade": "TR571",
            "mfi": "2026-02-03 00:00:00",
            "base": "OIL"
          },
          {
            "group": "Yarn",
            "grade": "6094",
            "mfi": "0.7-1.1",
            "base": "COAL"
          },
          {
            "group": "Yarn",
            "grade": "7750M",
            "mfi": "0.8",
            "base": "OIL"
          },
          {
            "group": "Yarn",
            "grade": "GF7750M2",
            "mfi": "3.3(5kg)",
            "base": "OIL"
          },
          {
            "group": "Yarn",
            "grade": "5000S",
            "mfi": "0.8-1.2",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "55110",
            "mfi": "11±4 (21.6kg)",
            "base": "COAL / OIL"
          },
          {
            "group": "Film",
            "grade": "FS7000",
            "mfi": "0.04",
            "base": "EDH"
          },
          {
            "group": "Film",
            "grade": "FS1460",
            "mfi": "0.05",
            "base": "EDH"
          },
          {
            "group": "Film",
            "grade": "9255",
            "mfi": "0.36-0.44",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "9252",
            "mfi": "0.22±0.07",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "F5703-S(HN7000)",
            "mfi": "0.22±0.07",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "HD5310",
            "mfi": "8-12(21.6kg)",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "HD 5704F",
            "mfi": "0.36-0.44",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "TR144",
            "mfi": "0.19±0.04",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "QZF144",
            "mfi": "0.19±0.04",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "6097",
            "mfi": "10(21.6kg)",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "ZH6098",
            "mfi": "10±3 (21.6kg)",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "6095",
            "mfi": "8-12(21.6kg)",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "6095H",
            "mfi": "10",
            "base": "OIL"
          },
          {
            "group": "Pipe 100-grade （natural Color）",
            "grade": "PN049",
            "mfi": "0.18-0.28 / 0.18-0.3 / 0.22-0.38",
            "base": "COAL / OIL"
          },
          {
            "group": "Pipe 100-grade （natural Color）",
            "grade": "23050",
            "mfi": "0.16-0.3 / 0.18-0.28(5kg) / 0.20-0.26",
            "base": "COAL / OIL"
          },
          {
            "group": "Pipe 100-grade （natural Color）",
            "grade": "QZP-10N",
            "mfi": "0.2~0.4",
            "base": "OIL"
          },
          {
            "group": "Pipe 100-grade （natural Color）",
            "grade": "FHMCRP100N (100N)",
            "mfi": "0.21-0.25",
            "base": "OIL"
          },
          {
            "group": "Pipe 100-grade （natural Color）",
            "grade": "N3000",
            "mfi": "0.3(5kg)",
            "base": "OIL"
          },
          {
            "group": "Pipe 100-grade （natural Color）",
            "grade": "P5003D-B(YGH041)",
            "mfi": "0.27(5kg)",
            "base": "OIL"
          },
          {
            "group": "Pipe(black)",
            "grade": "YGH041T",
            "mfi": "0.27(5kg)",
            "base": "OIL"
          },
          {
            "group": "Pipe(black)",
            "grade": "N3000B",
            "mfi": "0.3(5kg)",
            "base": "OIL"
          }
        ]
      },
      {
        "name": "LDPE",
        "grades": [
          {
            "group": "Film",
            "grade": "2426H",
            "mfi": "1.7-2.3",
            "base": "COAL / OIL"
          },
          {
            "group": "Film",
            "grade": "LD 100AC",
            "mfi": "1.7-2.3",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "TN26",
            "mfi": "1.8-3.0",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "Q281D",
            "mfi": "2",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "LD100PC",
            "mfi": "2",
            "base": "COAL"
          },
          {
            "group": "Film",
            "grade": "LD26D",
            "mfi": "0.3",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "18D",
            "mfi": "1.1-1.9",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "18D0",
            "mfi": "1.1-1.9",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "2420H",
            "mfi": "2",
            "base": "COAL / OIL"
          },
          {
            "group": "Film",
            "grade": "2102TNOO",
            "mfi": "1.8-3.0",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "2426K",
            "mfi": "4",
            "base": "COAL / OIL"
          },
          {
            "group": "Film",
            "grade": "2426F",
            "mfi": "0.74",
            "base": "OIL"
          },
          {
            "group": "Heavy-duty Film",
            "grade": "1810D",
            "mfi": "0.2-0.4",
            "base": "OIL"
          },
          {
            "group": "Heavy-duty Film",
            "grade": "2420D",
            "mfi": "0.25-0.35",
            "base": "COAL / OIL"
          },
          {
            "group": "Coating / Lamination",
            "grade": "19G",
            "mfi": "3.5-5.5",
            "base": "OIL"
          },
          {
            "group": "Coating / Lamination",
            "grade": "1C7A",
            "mfi": "7",
            "base": "OIL"
          },
          {
            "group": "Coating / Lamination",
            "grade": "LD251",
            "mfi": "8",
            "base": "COAL"
          }
        ]
      },
      {
        "name": "LLDPE",
        "grades": [
          {
            "group": "Film",
            "grade": "7050",
            "mfi": "1.8-2.2",
            "base": "COAL / OIL"
          },
          {
            "group": "Film",
            "grade": "1802",
            "mfi": "2",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "PE- L F182P",
            "mfi": "2",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "35H",
            "mfi": "2",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "7050H",
            "mfi": "2",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "7042",
            "mfi": "2",
            "base": "COAL / OIL"
          },
          {
            "group": "Film",
            "grade": "7042N",
            "mfi": "2",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "35B",
            "mfi": "1.7-2.3",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "PE-L F181CC(HNLP01)",
            "mfi": "1",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "1801",
            "mfi": "1",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "9047",
            "mfi": "1",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "9047N",
            "mfi": "1",
            "base": "OIL"
          },
          {
            "group": "Film",
            "grade": "7047",
            "mfi": "1",
            "base": "OIL"
          },
          {
            "group": "Injection",
            "grade": "8320",
            "mfi": "18-22",
            "base": "OIL"
          },
          {
            "group": "Injection",
            "grade": "2520",
            "mfi": "18-22",
            "base": "OIL"
          },
          {
            "group": "Injection",
            "grade": "M2320",
            "mfi": "20",
            "base": "OIL"
          },
          {
            "group": "Injection",
            "grade": "M2750",
            "mfi": "50",
            "base": "OIL"
          },
          {
            "group": "Injection",
            "grade": "DNDA 2020",
            "mfi": "19",
            "base": "OIL"
          },
          {
            "group": "Injection",
            "grade": "PE60",
            "mfi": "50",
            "base": "OIL"
          },
          {
            "group": "Rotational Moulding",
            "grade": "PE-L R335L (RW05U)",
            "mfi": "4.90-5.90",
            "base": "OIL"
          },
          {
            "group": "Rotational Moulding",
            "grade": "PE-L R3356HL (R546U)",
            "mfi": "4.50-5.50",
            "base": "OIL"
          },
          {
            "group": "Rotational Moulding",
            "grade": "DNDB-7149U",
            "mfi": "5",
            "base": "OIL"
          }
        ]
      }
    ]
  }
]
